const SHOPIFY_ADMIN_GRAPHQL_API = "shopify:admin/api/2026-01/graphql.json";

export default async ({ query, signal = null }) => {
  try {
    const response = await fetch(SHOPIFY_ADMIN_GRAPHQL_API, {
      method: "POST",
      signal,
      body: JSON.stringify({
        query,
      }),
    });

    if (!response.ok) throw new Error(response.statusText);

    return await response.json();
  } catch (error) {
    throw new Error(error);
  }
};
